// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609031132/js/" + chunkId + "." + {"44":"b04f6ffe","225":"5794568b","481":"e1f26e2f","486":"d30c1acb","770":"e277d2b2"}[chunkId] + ".0.3308326957836042.chunk.js";
};